import { setWaterMark, removeWatermark } from '@/utils/watermark'
import router from '@/router'
import { urlQueryfilter } from '@/utils/tools'
import { debounce } from 'lodash-es'
import store from '@/store'

interface State {
  userInfo: {
    name: string
    uid: string
    token: string
  } | null
  formCache: any
  userWaitProcessNum: number
}
interface CacheObj {
  key: string
  value: any
}

const state: State = {
  userInfo: JSON.parse(window.localStorage.getItem('userInfo') || 'null'),
  formCache: {},
  userWaitProcessNum: 0
}

const mutations = {
  setUserInfo(state: State, userInfo: any) {
    state.userInfo = userInfo
    // 将用户信息持久化存储
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    window.localStorage.setItem('Admin-Token', userInfo?.token)
    // 拿到用户信息后先加水印
    if (userInfo?.uid && userInfo?.name) {
      setWaterMark(userInfo?.uid, userInfo?.name)
    } else {
      removeWatermark()
    }
  },
  setUserInfoOnly(state: State, userInfo: any) {
    state.userInfo = userInfo
  },
  setFormCache(state: State, obj: CacheObj) {
    state.formCache[obj.key] = obj.value
  },
  removeFormCache(state: State) {
    state.formCache = {}
  },
  setUserWaitProcessNum(state: State, userWaitProcessNum: number) {
    state.userWaitProcessNum = userWaitProcessNum
  },
  redirectLogin(state: State, payload: any) {
    state.userInfo = null
    window.localStorage.removeItem('userInfo')

    store.commit('microAppCache/clear')

    // 子应用中有判断当前tab和当前路由是否一致逻辑，这里置空阻止子应用判断
    ;(this as any).commit('menu/setCurrentTab', null)

    const { pathname, search } = window.location
    // 如果上一个接口已经触发401跳转到login了，下一个接口在login才返回401，就不往下处理了，保留上一个接口的redirect让用户继续登录
    if (pathname === '/login') return

    const redirect = urlQueryfilter(`${pathname}${search}`, ['token'])
    toLogin(redirect)
  }
}
const getter = {}

const actions = {}

const toLogin = debounce((redirect: string) => {
  router.push({
    name: 'Login',
    query: {
      redirect
    }
  })
}, 300)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getter
}
